export default __webpack_public_path__ + "static/ourTechnologySection3_img1-ad05d1f83a2a4af00c070b7d5883ac5a.svg";